import { observable, action } from "mobx";
import CreditAccount from "./CreditAccount";

export default class CreditUsage {
  /**
   * @property {number|null}
   */
  @observable creditUsageId = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {number|null}
   */
  @observable productId = null;

  /**
   * @property {CreditAccount|null}
   */
  @observable creditAccount = null;

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action setData(data) {
    const { creditUsageId = null, tourId = null, productId = null, creditAccount = null } = data;

    this.creditUsageId = creditUsageId;
    this.tourId = tourId;
    this.productId = productId;

    if (creditAccount !== null) {
      this.creditAccount = new CreditAccount(creditAccount);
    } else {
      this.creditAccount = null;
    }
  }
}
